<app-message></app-message>
<div class="login">
	<div class="login-box">
		<form name="changePassWord" id="monitor-changePassWord"
			(ngSubmit)="submitChange()"
			[formGroup]="firstTimeLogin">
			<br>
			<h5 class="text-blue">Please
				change your temporary password
			</h5>

			<div class="form-group">
				<input
					formControlName="password"
					type="password"
					class="form-control"
					id="monitor_password"
					placeholder="Password"
					name="monitor_password"
					autocomplete="new-password"
					autofocus
					required>
			</div>
			<div class="form-group">

				<input
					formControlName="passwordRepeat"
					type="password"
					class="form-control"
					id="monitor_passwordRepeat"
					name="monitor_passwordRepeat"
					placeholder="Repeat Password"
					autocomplete="new-password"
					required>
			</div>
			<button
				class="btn btn-lg btn-primary btn-block"
				name="submit"
				type="submit">Change
				Password</button>
		</form>
	</div>
</div>
